import React, { Component } from 'react';
import PropTypes from 'prop-types';
import ParadigmaModal from "../../components/ParadigmaModal/ParadigmaModal.js"
import api from "../../api";

import { Input } from 'reactstrap';

import ParadigmaLabeledInput from "../../components/ParadigmaLabeledInput/ParadigmaLabeledInput.js"

class Modal extends Component {
    constructor(props) {
        super(props);
        this.state = {
            id: null,
            estado: "1",

            postVariables: ['estado'],
            errors: null,
        };
    }

    static propTypes = {
        onSubmit: PropTypes.func,
        id: PropTypes.func,
        action: PropTypes.oneOf(['CREATE', 'EDIT', 'DETAIL', 'DELETE']).isRequired,
    }

    resetForm() {
        this.setState({
            id: null,
            estado: "1",
            
            errors: null,
        });
    }

    getData() {
        const { postVariables } = this.state;
        let data = {
            'estado': this.state.estado,
        };

        return data;
    }

    setData(data) {
        if (data.success) {
            this.setState(prevState => {
                prevState.id = data.id;
                prevState.estado = data.estado;

                return prevState;
            });
        }
    }

    setErrors(errors) {
        this.setState({
            errors: errors,
        });
    }

    onChangeField(field, value) {
        this.setState(prevState => {
            let errors = prevState.errors;
            if (errors) errors[field] = null;
            prevState.errors = errors;
            prevState[field] = value;
            return prevState;
        });
    }

    getError(field, subfield) {
        let errors = this.state.errors;
        if (errors) {
            let _errors = errors[field];
            if (subfield) _errors = errors[field][subfield];
            return _errors;
        }
        else return null;
    }

    modalVars() {
        const { action } = this.props;
        if (action == "CREATE") {
            return {
                get: false,
                submitType: "POST",
                title: "Nuevo Escribania",
                buttonTitle: "Nuevo",
                danger: false,
                buttonIcon: "fa fa-plus fa-lg",
                successMessage: "El Escribania ha sido creado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                getDepth: 0,
            };
        } else if (action == "EDIT") {
            return {
                get: true,
                submitType: "PUT",
                title: "Editar Escribania",
                buttonTitle: "Editar",
                danger: false,
                buttonIcon: "fa fa-pencil fa-lg",
                successMessage: "El Escribania ha sido editado con éxito.",
                saveButton: true,
                saveButtonLabel: "Guardar",
                buttonClass: "",
                disabled: false,
                id: this.props.id,
                getDepth: 1,
            };
        } else if (action == "DETAIL") {
            return {
                get: true,
                submitType: null,
                title: "Escribania",
                buttonTitle: "Ver",
                danger: false,
                buttonIcon: "fa fa-search fa-lg",
                successMessage: "",
                saveButton: false,
                buttonClass: "",
                disabled: true,
                id: this.props.id,
                getDepth: 1,
            };
        } else if (action == "DELETE") {
            return {
                get: true,
                submitType: "DELETE",
                title: "Eliminar Escribania",
                buttonTitle: "Eliminar",
                danger: true,
                buttonIcon: "fa fa-trash fa-lg",
                successMessage: "El Proveedor ha sido eliminado con éxito.",
                saveButton: true,
                saveButtonLabel: "Eliminar",
                buttonClass: "btn-danger",
                disabled: true,
                id: this.props.id,
                getDepth: 1,
            };
        }
    }

    render() {
        let vars = this.modalVars();
        const { estado } = this.state;
        return (
            <ParadigmaModal
                getUrl={(vars.get ? api.escribania.escribania : null)}
                submitUrl={(vars.submitType ? api.escribania.escribania : null)}
                submitType={vars.submitType}
                id={vars.id}

                onGotData={(data) => this.setData(data)}
                onGotErrors={(errors) => this.setErrors(errors)}
                onSubmit={(e) => this.props.onSubmit(e)}
                onClose={() => this.resetForm()}
                onPreSubmit={() => this.getData()}

                title={vars.title}

                danger={vars.danger}
                buttonClass={vars.buttonClass}

                successMessage={vars.successMessage}
                missingIdMessage={"Debe seleccionar una fila."}
                saveButtonLabel={vars.saveButtonLabel}
                buttonTitle={vars.buttonTitle}
                buttonIcon={vars.buttonIcon}
                saveButton={vars.saveButton}
                closeButton={true}

                className="ui-paradigma-modal"
            >   

                <section className="ui-modal-section">
                    <p className="ui-section-label">Estado</p>
                    <div className="ui-form-grid">
                        <ParadigmaLabeledInput
                            md={[12, 12]}
                            classNames={["ui-field-label-col", "ui-field-control-col"]}
                            label={"Estado"}
                            error={() => this.getError('estado')}
                            inputComponent={
                                <Input
                                    type={'select'}
                                    value={estado}
                                    className="form-control"
                                    disabled={vars.disabled}
                                    onChange={(e) => this.setState({estado: e.target.value})}
                                    >
                                        <option value={"1"}>Pendiente</option>
                                        <option value={"2"}>Listo</option>
                                </Input>}
                        />
                    </div>
                </section>
            </ParadigmaModal>
        );
    }
}

export default Modal;



// WEBPACK FOOTER //
// ./src/views/Escribania/ModalEstado.js